"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
// https://www.sqlite.org/datatype3.html
const sqliteQueries = {
    int: {},
    integer: {},
    tinyint: {},
    smallint: {},
    mediumint: {},
    bigint: {},
    'unsigned big int': {},
    int2: {},
    int4: {},
    character: {},
    varchar: {},
    nchar: {},
    text: {},
    clob: {},
    'varying character': {},
    'native character': {},
    blob: {},
    real: {},
    double: {},
    'double precision': {},
    float: {},
    numeric: {},
    decimal: {},
    boolean: {},
    date: {},
    datetime: {}
};
const _default = sqliteQueries;
